if (!customElements.get("tab-content-wrapper")) {
    class TabContentWrapper extends HTMLElement {
        constructor() {
            super();
            this.tabButtons = this.querySelectorAll("[tab-button]");
            this.tabPanels = this.querySelectorAll("[tab-panel]");
            this.initLazySection();
        }

        setActiveButton(activeButton) {
            this.tabButtons.forEach((btn) => {
                btn.removeAttribute("data-active");
                btn.setAttribute("aria-selected", "false");
            });
            
            if (activeButton) {
                activeButton.setAttribute("data-active", "");
                activeButton.setAttribute("aria-selected", "true");
            }
        }

        setActivePanel(activePanel) {
            this.tabPanels.forEach((panel) => {
                panel.removeAttribute("open");
                panel.setAttribute("aria-hidden", "true");
            });
            if (activePanel) {
                activePanel.setAttribute("open", "");
                activePanel.setAttribute("aria-hidden", "false");
            }
        }

        initLazySection() {
            if (this.tabButtons.length > 0) {
                const openPanel = this.querySelector("[tab-panel][open]");
                if (openPanel) {
                    const panelId = openPanel.getAttribute("id");
                    const activeBtn = Array.from(this.tabButtons).find(
                        (btn) => btn.getAttribute("panel-for") === panelId,
                    );
                    this.setActiveButton(activeBtn);
                }

                this.tabButtons.forEach((el) => {
                    el.addEventListener("click", (e) => {
                        e.preventDefault();
                        const panelFor =
                            e?.currentTarget.getAttribute("panel-for");
                        const selectedPanel = this.querySelector(
                            `#${panelFor}`,
                        );
                        this.setActivePanel(selectedPanel);
                        this.setActiveButton(e.currentTarget);
                    });

                    el.addEventListener("keydown", (e) => {
                        let targetTab = null;
                        const tabs = Array.from(this.tabButtons);
                        const currentIndex = tabs.indexOf(e.currentTarget);

                        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                            e.preventDefault();
                            targetTab = tabs[currentIndex + 1] || tabs[0];
                        } else if (
                            e.key === "ArrowLeft" ||
                            e.key === "ArrowUp"
                        ) {
                            e.preventDefault();
                            targetTab =
                                tabs[currentIndex - 1] || tabs[tabs.length - 1];
                        } else if (e.key === "Home") {
                            e.preventDefault();
                            targetTab = tabs[0];
                        } else if (e.key === "End") {
                            e.preventDefault();
                            targetTab = tabs[tabs.length - 1];
                        }

                        if (targetTab) {
                            targetTab.focus();
                            const panelFor =
                                targetTab.getAttribute("panel-for");
                            const selectedPanel = this.querySelector(
                                `#${panelFor}`,
                            );
                            this.setActivePanel(selectedPanel);
                            this.setActiveButton(targetTab);
                        }
                    });
                });
            }
        }
    }

    customElements.define("tab-content-wrapper", TabContentWrapper);
}
